import { TripAlertBranding } from '../../account/settings/branding/TripAlertBranding';
import {
  setBrandingImage,
  uploadPreviewBrandingImage,
} from '../../service/accountService';
import React, { useState, useEffect, useCallback } from 'react';

interface Props {
  isCurrentImageLoading: boolean;
  brandingImageUrl: string;
  hasErrorGettingImages: boolean;
  fetchBrandingImageUrl: () => void;
}

const previewBrandingImagePages = (previewBrandingImageUrl: string) => [
  {
    name: 'Register Page',
    href: `/traveler/register/preview?brandingImageUrl=${previewBrandingImageUrl}`,
  },
  {
    name: 'Login Page',
    href: `/traveler/login/preview?brandingImageUrl=${previewBrandingImageUrl}`,
  },
  {
    name: 'Profile Page',
    href: `/traveler/profile/preview?brandingImageUrl=${previewBrandingImageUrl}`,
  },
];

const TripAlertBrandingContainer: React.FC<Props> = ({
  isCurrentImageLoading,
  brandingImageUrl,
  hasErrorGettingImages,
  fetchBrandingImageUrl,
}) => {
  const [file, setFile] = useState<File | undefined>(undefined);
  const [previewImage, setPreviewImage] = useState<string | undefined>(undefined);
  const [hasPreviewError, setHasPreviewError] = useState<boolean>(false);
  const [previewBrandingImageId, setPreviewBrandingImageId] = useState<
    string | undefined
  >(undefined);
  const [previewBrandingImageUrl, setPreviewBrandingImageUrl] = useState<
    string | undefined
  >(undefined);
  const [successfulSave, setSuccessfulSave] = useState<boolean>(false);
  const [failedSave, setFailedSave] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      if (previewImage) {
        URL.revokeObjectURL(previewImage);
      }
    };
  }, [previewImage]);

  const handleSave = useCallback(
    (previewBrandingImageId: string | undefined) => {
      if (previewBrandingImageId) {
        setBrandingImage(previewBrandingImageId)
          .then(() => {
            fetchBrandingImageUrl();
            setFile(undefined);
            setPreviewImage(undefined);
            setPreviewBrandingImageUrl(undefined);
            setSuccessfulSave(true);
          })
          .catch(() => setFailedSave(true));
      }
    },
    [],
  );

  const imageUploadAccepted = (file: File) => {
    uploadPreviewBrandingImage(file)
      .then(response => {
        setPreviewBrandingImageId(response.id);
        setPreviewBrandingImageUrl(response.url);
      })
      .catch(() => setHasPreviewError(true));
    if (previewImage) {
      URL.revokeObjectURL(previewImage);
    }
    const newPreviewImage = URL.createObjectURL(file);
    setFile(file);
    setPreviewImage(newPreviewImage);
  };

  const imageUploadRejected = () => {
    if (previewImage) {
      URL.revokeObjectURL(previewImage);
    }
    setFile(undefined);
    setPreviewImage(undefined);
    setPreviewBrandingImageUrl(undefined);
  };

  return (
    <TripAlertBranding
      isCurrentImageLoading={isCurrentImageLoading}
      currentImage={brandingImageUrl}
      hasCurrentImageError={hasErrorGettingImages}
      uploadFile={file}
      onImageAccepted={imageUploadAccepted}
      onImageRejected={imageUploadRejected}
      previewImage={previewImage}
      hasPreviewError={hasPreviewError}
      previewBrandingImagePages={
        previewBrandingImageUrl
          ? previewBrandingImagePages(previewBrandingImageUrl)
          : undefined
      }
      onSave={() => handleSave(previewBrandingImageId)}
      successfulSave={successfulSave}
      failedSave={failedSave}
    />
  );
};

export default TripAlertBrandingContainer;
